export const STARTVIDEOTRACKING = 'STARTVIDEOTRACKING'